import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana57: React.FC = () => {
  const Notice1 = `Desde nuestra curul verde del @concejocali Celebramos la desición mayoritaria del @partidoalianzaverde de apoyar la candidatura de @ivancepedacastr a la presidencia y @aida_quilcue a la vicepresidencia, así como la suscripción de un 𝙖𝙘𝙪𝙚𝙧𝙙𝙤 𝙥𝙧𝙤𝙜𝙧𝙖𝙢𝙖𝙩𝙞𝙘𝙤 𝙦𝙪𝙚 𝙧𝙚𝙘𝙤𝙜𝙚 𝙡𝙖𝙨 𝙗𝙖𝙣𝙙𝙚𝙧𝙖𝙨 𝙫𝙚𝙧𝙙𝙚𝙨 𝙙𝙚: Justicia ambiental y conectividad ecológica, defensa de los animales, reforma agraria y desarrollo rural, educación, descentralización y desarrollo económico y garantía y protección de derechos. ♻️🌎

Ni el #PlanJúpiter, ni los intentos de la ultraderecha y bandas criminales con sus planes terroristas de desestabilización y pánico podrán detener la continuidad de la fuerza del cambio, que el pueblo soberano sabrá defender en las urnas con el triunfo en primera.

𝑬𝑳 𝑪𝑨𝑴𝑩𝑰𝑶 𝑬𝑺 𝑪𝑶𝑵 𝑽𝑶𝑺‼️ 🫂`;

  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DXkfDbyiems/"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>𝑬𝑳 𝑪𝑨𝑴𝑩𝑰𝑶 𝑬𝑺 𝑪𝑶𝑵 𝑪𝑬𝑷𝑬𝑫𝑨, 𝑬𝑳 𝑪𝑨𝑴𝑩𝑰𝑶 𝑬𝑺 𝑬𝑵 𝑷𝑹𝑰𝑴𝑬𝑹𝑨. 🇨🇴🗳️ </h1>
        <h5 className={style.Fecha}>Abril 25 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
